import { Component, OnInit, Output, EventEmitter, ElementRef, ViewChild, input } from '@angular/core';
import { ContextService } from '../../context.service';
import tinycolor from 'tinycolor2';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
  standalone: false
})
export class ColorPickerComponent extends FieldType implements OnInit {

  readonly selectedColorHex = input<string>('#EF5350');
  readonly colorType = input<string>('primary');
  readonly displayPalette = input<boolean>(false);
  @Output() newItemEvent = new EventEmitter<object>();
  @ViewChild('colorInput', { static: true }) colorInput: ElementRef | undefined;
  cmykValue: string | undefined;
  selectedColorVariations: any[] = [];

  private colorMap: any = {
    '50': { dark: false, value: 12 },
    '300': { dark: false, value: 70 },
    '500': { dark: false, value: 100 },
    '700': { dark: true, value: 70 },
    '900': { dark: true, value: 25 },
    'A100': { dark: true, value: 15, saturation: 80, light: 65 },
    'A200': { dark: true, value: 15, saturation: 80, light: 55 },
    'A400': { dark: true, value: 15, saturation: 100, light: 45 },
    'A700': { dark: true, value: 15, saturation: 100, light: 40 }
  };

  constructor(
    public contextSettings: ContextService, public host: ElementRef
  ) { super(); }

  ngOnInit(): void {
    this.contextSettings.showProgress(false);
    this.selectedColorHex.apply(this.formControl?.value ?? this.selectedColorHex());
    this.buildColorMaps(this.selectedColorHex());
  }

  setSelectedColor(newColorHex: any) {
    this.buildColorMaps(newColorHex);
    this.selectedColorHex.apply(newColorHex);
    this.newItemEvent.emit({ 'type': this.colorType(), 'hex': newColorHex });
  }

  buildColorMaps(newColorHex: any) {
    this.selectedColorVariations = [];

    let color = new tinycolor(newColorHex),
      light = new tinycolor('#ffffff'),
      black = new tinycolor('#000000'),
      dark = new tinycolor(this.__colorAdjust(color)),
      triad = color.tetrad()[3];
    // Walk the map and build the full color profile as used in the application
    Object.keys(this.colorMap).forEach((level: string) => {
      let defn = this.colorMap[level],
        newColor = tinycolor.mix(defn.dark ? dark : light,
          !defn.saturation ? color : triad,
          defn.value);//.saturate(defn.saturation ?? 100).lighten(defn.light ?? 0);
      if (!!defn.saturation) {
        newColor = newColor.saturate(defn.saturation);
      }
      if (!!defn.light) {
        newColor = newColor.lighten(defn.light);
      }

      this.selectedColorVariations.push({
        weight: level,
        hex: '#' + newColor.toHex()
      });

    });
  }

  __colorAdjust(tc: any) {
    return new tinycolor({
      r: Math.floor(Math.pow(tc._r, 2) / 255),
      b: Math.floor(Math.pow(tc._b, 2) / 255),
      g: Math.floor(Math.pow(tc._g, 2) / 255)
    });
  }
}